import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface MobileListItemBadgeProps {
  children: ReactNode;
  variant?: "default" | "success" | "warning" | "error" | "info";
  className?: string;
}

export function MobileListItemBadge({
  children,
  variant = "default",
  className,
}: MobileListItemBadgeProps) {
  const variantClasses = {
    default: "bg-gray-100 text-gray-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    error: "bg-red-100 text-red-800",
    info: "bg-blue-100 text-blue-800",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-1 rounded-full text-sm font-medium",
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
